import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import { DarkModeContext } from "./context/darkModeContext";
import { AuthContext } from "./context/AuthContext";

import Login from "./pages/login/Login";
import CustomUrlPage from "./pages/list/CustomUrlPage";

import "./style/dark.scss";
import NotFound from "./404";

// Route wrapper that validates and corrects companyId/locationId in the URL
function AliasPanelRoute() {
  const { currentUser } = useContext(AuthContext);
  const { companyId, locationId } = useParams();

  if (!currentUser) return <Login />;

  // Redirect to correct path if params don't match current user's info
  if (
    companyId !== currentUser.companyId ||
    locationId !== currentUser.locationId
  ) {
    return (
      <Navigate
        to={`/watch-swap/${currentUser.companyId}/${currentUser.locationId}`}
        replace
      />
    );
  }

  return <CustomUrlPage />;
}

function App() {
  const { darkMode } = useContext(DarkModeContext);
  const { currentUser } = useContext(AuthContext);

  const [userLocationId, setUserLocationId] = useState("");
  const [userCompanyId, setUserCompanyId] = useState("");

  useEffect(() => {
    if (currentUser) {
      setUserLocationId(currentUser.locationId || "");
      setUserCompanyId(currentUser.companyId || "");
    } else {
      setUserLocationId("");
      setUserCompanyId("");
    }
  }, [currentUser]);

  return (
    <div className={darkMode ? "app dark" : "app"}>
      <BrowserRouter>
        <Routes>
          {/* Alias Panel Routes */}
          <Route
            path="watch-swap/:companyId/:locationId"
            element={<AliasPanelRoute />}
          />
          <Route
            path="watch-swap/:companyId/:locationId/login"
            element={<AliasPanelRoute />}
          />

          {/* Login Redirect */}
          <Route
            path="/login"
            element={
              currentUser ? (
                <Navigate
                  to={`/watch-swap/${currentUser.companyId}/${currentUser.locationId}`}
                />
              ) : (
                <Login />
              )
            }
          />

          {/* 404 Route */}
          <Route path="/watch-swap/404" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
